/**
 * The years a year picker offers: the current year always, whatever the
 * organisation has reservations for, and the selected year even when it has no
 * data — a control must offer the value it is showing. Newest first.
 */
export function mergeYearOptions(
  currentYear: number,
  selectedYear: number,
  dataYears: number[] | undefined
): number[] {
  const years = new Set<number>([currentYear, selectedYear, ...(dataYears ?? [])]);
  return [...years].sort((a, b) => b - a);
}
